import { observer } from 'mobx-react';
import * as React from 'react';

import { SelectFilterWithSearch } from 'components/Filter/DefaultFilters';

import { helperDistancesStore } from 'stores';

type Props = {} & FilterProps;

@observer
class WaveIdComponent extends React.Component<Props> {
  options = () => {
    const distanceModel = helperDistancesStore.modelSelected;

    if (!distanceModel) {
      return [];
    }

    return distanceModel.relationForSelect('waves');
  };

  render() {
    const { props } = this;
    return <SelectFilterWithSearch {...props} options={this.options()} />;
  }
}

export const waveId: FilterListDescriptor = {
  filter: {
    persistance: {
      handler: '=',

      calcValue: function (name, value) {
        return value;
      },

      prettify: function (name, value) {
        const distance = helperDistancesStore.modelSelected;

        if (!distance) {
          return null;
        }

        const waveModel = distance.findRelationModelValue('waves', +value);
        return waveModel && waveModel.label();
      },
    },
  },

  frontend: {
    type: 'custom',
    component: WaveIdComponent,
  },
};
